// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChallengeSudoku_wrapper__nn_2h","adsWrapper":"ChallengeSudoku_adsWrapper__qUYFP"};